import React, { useState } from "react";
import Axios from "axios";
import useHeader from "../../../hook/useHeader";

function PaymentTerm() {
  const url = process.env.REACT_APP_API_URI + process.env.REACT_APP_cht;
  const bearer = useHeader();

  Axios.defaults.headers.common = {
    Authorization: "Bearer " + bearer,
  };

  const [edit, setEdit] = useState(false);
  return (
    <section id="payment-term">
      <div className="border border-zinc-300 rounded-md relative">
        <div className="absolute bg-white px-2 py-1 -top-4 left-3 text-red-600">
          Payment Term
        </div>
        <div className="px-3 py-4 grid md:grid-cols-3 gap-x-2 mt-2">
          <div className="flex gap-2 items-center">
            <label htmlFor="pt1" className="w-[140px]">
              Deposit
            </label>
            <input
              type="text"
              id="pt1"
              className={`${!edit ? "border-none" : ""} text-right w-full`}
              disabled={!edit}
            />
          </div>
          <div className="flex gap-2 items-center">
            <label htmlFor="dd1" className="w-[140px]">
              Due Date
            </label>
            <input
              type="text"
              id="dd1"
              className={`${!edit ? "border-none" : ""} text-right w-full`}
              disabled={!edit}
            />
          </div>
          <div className="flex gap-2 items-center">
            <label htmlFor="extra" className="w-[140px]">
              Extra Condition
            </label>
          </div>
          <div className="flex gap-2 items-center">
            <label htmlFor="pt2" className="w-[140px]">
              Payment 1
            </label>
            <input
              type="text"
              id="pt2"
              className={`${!edit ? "border-none" : ""} text-right w-full`}
              disabled={!edit}
            />
          </div>
          <div className="flex gap-2 items-center">
            <label htmlFor="dd2" className="w-[140px]">
              Due Date
            </label>
            <input
              type="text"
              id="dd2"
              className={`${!edit ? "border-none" : ""} text-right w-full`}
              disabled={!edit}
            />
          </div>
          <div>
            <textarea
              rows={2}
              id="extra"
              className={`${
                !edit
                  ? "border-none"
                  : "border border-gray-400 rounded-md outline-none p-1"
              } text-right w-full focus:shadow-[0_0_0_0.2rem_white,0_0_5px_0.25rem_red] focus:border-white`}
              disabled={!edit}
            />
          </div>
          <div className="flex gap-2 items-center">
            <label htmlFor="pt3" className="w-[140px]">
              Payment 2
            </label>
            <input
              type="text"
              id="pt3"
              className={`${!edit ? "border-none" : ""} text-right w-full`}
              disabled={!edit}
            />
          </div>
          <div className="flex gap-2 items-center">
            <label htmlFor="dd3" className="w-[140px]">
              Due Date
            </label>
            <input
              type="text"
              id="dd3"
              className={`${!edit ? "border-none" : ""} text-right w-full`}
              disabled={!edit}
            />
          </div>
          <div className="flex justify-end">
            <button
              className={`${edit ? "btn-primary" : "btn-green"} px-3`}
              onClick={() => setEdit(!edit)}
            >
              {!edit ? "Edit" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PaymentTerm;
